import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { programGridZoomSearchSchema } from "src/contexts/ProgramGridZoomContext";
import { CoachLibrarySharedProgramDetailsPage } from "src/pages/CoachLibrarySharedProgramDetailsPage";

const routeSearchSchema = z.object({
  openFirstWorkout: z.boolean().optional(),
  selectedWorkout: z.string().optional(),
  workoutItemId: z.string().optional(),
  zoom: programGridZoomSearchSchema,
});

export const Route = createFileRoute(
  "/_auth/_coach/library/programs/$programId/shared/$sharedProgramId/",
)({
  component: CoachLibrarySharedProgramDetailsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
});
